<template>
  <div class="model_container">
    <div style="clear:both">
      <el-form v-if="carId" label-position="top" ref="form" :model="imgForm" action="javascript:void(0)">
        <el-form-item label="车型选择">
          <el-select v-model="imgForm.carId" @change="getImageList(1)">
            <el-option v-for="item in carTypes" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部件">
          <el-select v-model="imgForm.imgType" @change="getImageList(1)">
            <el-option v-for="(item, index) in imgTypes" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>

        </el-form-item>
      </el-form>
    </div>
    <div class="infinite-list" style="scrollbar-width: none;overflow:auto" v-infinite-scroll="loadMoreImg"
      :infinite-scroll-distance=500 :infinite-scroll-delay=300 :infinite-scroll-immediate=true
      :infinite-scroll-disabled='loadingFinish'>
      <ul style="width:100%;margin: 0;padding: 0;">
        <div class="imgMasonryContainer" transition-duration="0.3s" item-selector=".imgItem">
          <div class="imgItem">
            <div class="imageContainer">
              <el-link :underline="false" @click="uploadImgDialogVisible = true" style="width: 100%; height: 100%;">
                <el-image style="width: 100%; height: 100%;" src='static/imgs/addImgBtn.png' fit="scale-down">
                </el-image>
              </el-link>
              <div style="clear:both"></div>
            </div>
          </div>
          <div class="imgItem" :key="index" v-for="(item, index) in imageList">
            <div class="imageContainer">
              <el-image :src="item.imgUrl + '?w=200&h=200&t=r'" @load="imgLoadSucc" fit="cover"></el-image>
              <div style="clear:both"></div>
              <div class="imgOpreateContainer">
                <el-row v-if="imgForm.carId">
                  <el-col :span="24">
                    <el-link :underline="false" @click="insertImg(item.imgUrl)">引用</el-link>
                  </el-col>

                </el-row>
                <el-row v-else>
                  <el-col :span="12">
                    <el-link :underline="false" @click="insertImg(item.imgUrl)">引用</el-link>
                  </el-col>
                  <el-col :span="12">
                    <el-link :underline="false" @click="deleteImg(item.id, index)">删除</el-link>
                  </el-col>
                </el-row>
              </div>
              <div style="clear:both"></div>
            </div>
          </div>
          <div style="clear:both"></div>
        </div>
        <div style="clear:both"></div>
        <template v-if="loadingFinish">
          <div class="noData">
            <i class="iconfont">&#xe629;</i>
            数据加载完毕!
          </div>
        </template>
        <template v-else>
          <div class="noData">
            <span class="icon_run">
              <i class="iconfont">&#xe67b;</i>
            </span>数据加载中...
          </div>
        </template>
      </ul>
    </div>

    <!--- 上传图片----->
    <!--上传图片对话框--->
    <el-dialog title="上传图片" :visible.sync="uploadImgDialogVisible" width="500px" :modal-append-to-body="true"
      :append-to-body="true">
      <el-upload class="upload-demo" drag :on-success="imgUpSucc" :on-error="imgUpError"
        action="/webApi/v3/clientUserImg/uploadImg" multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
      </el-upload>
    </el-dialog>
  </div>
</template>
<script>
import Masonry from 'masonry-layout'
export default {
  props: ['carId', 'articleInfo'],
  components: {
  },
  name: 'bindMobile',
  data: function () {
    return {
      carTypes: [],
      loadingFinish: false,
      uploadImgDialogVisible: false,
      defaultImg: '../assets/imgs/addImgBtn.png',
      imageList: [],
      imgTypes: [],
      imgForm: {
        carId: '',
        imgType: '外观'
      }
    }
  },
  metaInfo () {
    return {
      title: '弈写AI辅助写作'
    }
  },
  methods: {
    // 删除图片
    deleteImg (id, index) {
      let _this = this
      this.axios.get('/webApi/v3/clientUserImg/recycleImg?imgId=' + id).then(resp => {
        _this.$message({
          message: '图片删除成功',
          type: 'success'
        });
        _this.imageList.splice(index, 1)
        setTimeout(function () {
          _this.msnry = new Masonry('.imgMasonryContainer', {});
          _this.msnry.layout()
        }, 500)
      })
    },
    // 插入图片
    insertImg (url) { // 暂时去掉权限检查
      let temp = '<img style="max-width:100%" src="' + url + '"/>';
      this.$emit('insertHtml', temp)
    },

    imgLoadSucc () {
      setTimeout(function () {
        if (document.getElementsByClassName('imgMasonryContainer').length > 0) {
          this.msnry = new Masonry('.imgMasonryContainer', {});
          if (this.msnry) {
            this.msnry.layout()
          }
        }
      }, 500)
    },
    // 上传图片
    imgUpSucc (response, file, fileList) {
      if (this.isUpLoading) {
        return
      }
      this.isUpLoading = true
      let _this = this
      setTimeout(function () {
        if (response.code === 200) {
          _this.$notify({
            title: '成功',
            message: '文件【' + file.name + '】上传成功',
            type: 'success'
          })
          _this.pageNo = 1
          _this.imageList = []
          _this.getImageList()
          _this.uploadImgDialogVisible = false
          _this.loadingFinish = false
          _this.isUpLoading = false
        } else {
          _this.$notify.error({
            title: '错误',
            message: response.msg
          })
        }
      }, 500)
    },
    imgUpError (errorInfo, file, fileList) {
      this.$notify.error({
        title: '错误',
        message: '文件【' + file.name + '】上传失败'
      })
    },
    // 获取更多图片
    loadMoreImg () {
      this.pageNo++
      this.getImageList(this.pageNo)
    },

    // 获取图片列表
    getImageList (pageNo) {
      if (!pageNo || pageNo === 1) {
        this.imageList = []
        this.pageNo = 1
      }
      let _this = this
      this.pageSize = 10

      if (this.imgForm.carId && this.imgForm.imgType) {
        _this.imgForm.page = _this.pageNo
        _this.imgForm.pageSize = _this.pageSize
        this.axios.post('/webApi/carImg/listByPage', _this.imgForm).then((response) => {
          response.data.rows.forEach(e => {
            _this.imageList.push(e)
          })
          if (response.data.rows.length === 0) {
            _this.loadingFinish = true
            _this.imgLoadSucc()
          }
        })
      } else {
        this.axios.post('/webApi/v3/clientUserImg/listData', { 'page': _this.pageNo, 'pageSize': _this.pageSize, 'keyword': '', '$noLoading': true }).then((response) => {
          response.data.rows.forEach(e => {
            _this.imageList.push(e)
          })
          if (response.data.rows.length === 0) {
            _this.loadingFinish = true
            _this.imgLoadSucc()
          }
        })
      }
    }
  },
  computed: {

  },
  watch: {

  },
  mounted () {
    this.imgForm.carId = this.carId
    if (this.articleInfo.carId) {
      this.imgForm.carId = this.articleInfo.carId
    }
    let _this = this
    this.axios.get('/webApi/carType/listAll').then(resp => {
      _this.carTypes = resp.data.list
    })
    this.axios.get('/webApi/carImg/imgTypes').then(resp => {
      _this.imgTypes = resp.data
      _this.imgForm.imgType = resp.data[0]
      if (_this.imgForm.carId) {
        _this.getImageList(1)
      } else {
        _this.getImageList(1)
      }
    })
  }
}

</script>
<style lang="less">
.imgMasonryContainer {
  min-height: 200px;

  .item {}
}
</style>



// WEBPACK FOOTER //
// src/components/article/imageTab.vue